module.exports = __webpack_public_path__ + "img/logo.a99fedc3.png";